import Image from 'next/image'
import Skeleton from 'react-loading-skeleton'

const FleetsCardsSkeleton = ({isShowSkeletonTabs = false , tabsAlignment = 'left'}) => {
  return (
    <>
    {isShowSkeletonTabs &&
      <div className={`flex w-full items-center mb-7 ${tabsAlignment === 'left' ? 'justify-start' : 'justify-center'}`}>
        <div className='cursor-pointer block lg:hidden'>
          <Skeleton circle={true} height={28} width={28} />
        </div>

        <div
          id='fleet-tabs-container'
          className='flex gap-5 overflow-x-scroll max-w-full items-center justify-center  h-[28px]'
        >
          {Array.from({ length: 10 }).map((_, index) => (
            <div key={index} className='relative'>
              <Skeleton width={33} height={25} borderRadius={4} />
            </div>
          ))}
        </div>

        <div className='cursor-pointer block lg:hidden'>
          <Skeleton circle={true} height={28} width={28} />
        </div>
      </div>
}
      <div className='flex items-center '>
        <div className='w-full xl:min-w-[278px] sm:min-w-[346px] md:min-w-[230px]'>
          <div className='bg-[#FBFBFB] min-h-[270px] box-car-shadow flex flex-col font-light items-center shadow-[0px_1px_2px_1px_rgba(0_0_0/0.1)] m-2 px-6 py-[30px]'>
            <div className='min-h-[104.5px] flex w-full justify-center items-center mb-[15px]'>
              <Image
                src='https://storage.googleapis.com/rolzo-static-bucket/images/car-placeholder.png'
                className='max-w-full object-contain w-full'
                alt='Rolzo Fleet Placeholder'
                width={209}
                height={36}
              />
            </div>
            <small className='text-rolzo-grey text-[12px] uppercase mb-2'>
              <Skeleton width={60} height={12} />
            </small>
            <h6 className='text-[#212529] whitespace-nowrap overflow-hidden text-ellipsis mb-2 max-w-full'>
              <Skeleton width={120} height={18} />
            </h6>
            <Skeleton width={93} height={15} className='mb-5' />
            <Image
              width={12}
              height={12}
              className='w-auto h-3 opacity-0'
              src='https://storage.googleapis.com/rolzo-static-bucket/images/ROLZO_Leaf_badge_Positive_Green.png'
              alt='Rolzo Booking Placeholder'
            />
          </div>
        </div>
        <div className='w-full xl:min-w-[278px] sm:min-w-[346px] md:min-w-[230px] hidden sm:block'>
          <div className='bg-[#FBFBFB] min-h-[270px] box-car-shadow flex flex-col font-light items-center shadow-[0px_1px_2px_1px_rgba(0_0_0/0.1)] m-2 px-6 py-[30px]'>
            <div className='min-h-[104.5px] flex w-full justify-center items-center mb-[15px]'>
              <Image
                src='https://storage.googleapis.com/rolzo-static-bucket/images/car-placeholder.png'
                className='max-w-full object-contain w-full'
                alt='Rolzo Fleet Placeholder'
                width={209}
                height={36}
              />
            </div>
            <small className='text-rolzo-grey text-[12px] uppercase mb-2'>
              <Skeleton width={60} height={12} />
            </small>
            <h6 className='text-[#212529] whitespace-nowrap overflow-hidden text-ellipsis mb-2 max-w-full'>
              <Skeleton width={120} height={18} />
            </h6>
            <Skeleton width={93} height={15} className='mb-5' />
            <Image
              width={12}
              height={12}
              className='w-auto h-3 opacity-0'
              src='https://storage.googleapis.com/rolzo-static-bucket/images/ROLZO_Leaf_badge_Positive_Green.png'
              alt='Rolzo Booking Placeholder'
            />
          </div>
        </div>
        <div className='w-full xl:min-w-[278px] sm:min-w-[346px] md:min-w-[230px] hidden md:block'>
          <div className='bg-[#FBFBFB] min-h-[270px] box-car-shadow flex flex-col font-light items-center shadow-[0px_1px_2px_1px_rgba(0_0_0/0.1)] m-2 px-6 py-[30px]'>
            <div className='min-h-[104.5px] flex w-full justify-center items-center mb-[15px]'>
              <Image
                src='https://storage.googleapis.com/rolzo-static-bucket/images/car-placeholder.png'
                className='max-w-full object-contain w-full'
                alt='Rolzo Fleet Placeholder'
                width={209}
                height={36}
              />
            </div>
            <small className='text-rolzo-grey text-[12px] uppercase mb-2'>
              <Skeleton width={60} height={12} />
            </small>
            <h6 className='text-[#212529] whitespace-nowrap overflow-hidden text-ellipsis mb-2 max-w-full'>
              <Skeleton width={120} height={18} />
            </h6>
            <Skeleton width={93} height={15} className='mb-5' />
            <Image
              width={12}
              height={12}
              className='w-auto h-3 opacity-0'
              src='https://storage.googleapis.com/rolzo-static-bucket/images/ROLZO_Leaf_badge_Positive_Green.png'
              alt='Rolzo Booking Placeholder'
            />
          </div>
        </div>
        <div className='w-full xl:min-w-[278px] sm:min-w-[346px] md:min-w-[230px] hidden xl:block'>
          <div className='bg-[#FBFBFB] min-h-[270px] box-car-shadow flex flex-col font-light items-center shadow-[0px_1px_2px_1px_rgba(0_0_0/0.1)] m-2 px-6 py-[30px]'>
            <div className='min-h-[104.5px] flex w-full justify-center items-center mb-[15px]'>
              <Image
                src='https://storage.googleapis.com/rolzo-static-bucket/images/car-placeholder.png'
                className='max-w-full object-contain w-full'
                alt='Rolzo Fleet Placeholder'
                width={209}
                height={36}
              />
            </div>
            <small className='text-rolzo-grey text-[12px] uppercase mb-2'>
              <Skeleton width={60} height={12} />
            </small>
            <h6 className='text-[#212529] whitespace-nowrap overflow-hidden text-ellipsis mb-2 max-w-full'>
              <Skeleton width={120} height={18} />
            </h6>
            <Skeleton width={93} height={15} className='mb-5' />
            <Image
              width={12}
              height={12}
              className='w-auto h-3 opacity-0'
              src='https://storage.googleapis.com/rolzo-static-bucket/images/ROLZO_Leaf_badge_Positive_Green.png'
              alt='Rolzo Booking Placeholder'
            />
          </div>
        </div>
        {/* <div className='content-preloader flex items-center flex-wrap mt-6'>
                           <div className='c-preloader' >
                                <div className='card-loader card-loader--tabs'>
                                   <img src='https://storage.googleapis.com/rolzo-static-bucket/images/car-placeholder.png' alt="Car placeholder" />
                                </div>
                            </div>
                           <div className='c-preloader !hidden md:!inline-block' >
                               <div className='card-loader card-loader--tabs'>
                                    <img src='https://storage.googleapis.com/rolzo-static-bucket/images/car-placeholder.png' alt="Car placeholder" />
                                </div>
                           </div>
                            <div className='c-preloader !hidden md:!inline-block'>
                               <div className='card-loader card-loader--tabs'>
                                   <img src='https://storage.googleapis.com/rolzo-static-bucket/images/car-placeholder.png' alt="Car placeholder" />
                               </div>
                           </div>
                   </div> */}
      </div>
    </>
  )
}

export default FleetsCardsSkeleton
